// extracted by mini-css-extract-plugin
export default {"list":"ScrollList_list__cdtRk"};